module.exports = __webpack_public_path__ + "img/results.5bc009c4.jpg";